<template>
  <div>
    <v-sheet elevation="0" color="#57bc90" style="min-height: 100vh">
      <!-- //* game summary weekly... -->
      <div class="pa-2">
        <p class="text-h5 white--text font-weight-bold pt-3">Recent Game</p>
        <v-data-table
          :headers="dynamicRecentHeader"
          :items="stats.data"
          class="elevation-1"
          hide-default-footer
          sort-by="Week"
          sort-desc
          mobile-breakpoint="0"
        >
          <!-- header -->
          <template
            v-for="h in dynamicRecentHeader"
            v-slot:[`header.${h.value}`]="{ dynamicRecentHeader }"
          >
            <v-tooltip bottom :key="h.text">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ h.text }}</span>
              </template>
              <span>{{ h.hint }}</span>
            </v-tooltip>
          </template>
          <!-- header -->

          <template v-slot:item.Day="{ item }">
            <p class="blue--text">{{ item.Day | dayFormatV2 }}</p>
          </template>

          <template v-slot:item.FantasyPointsDraftKings="{ item }">
            <p v-if="operator === 'FanDuel'" class="body-2">
              {{ item.FantasyPointsFanDuel }}
            </p>

            <p v-if="operator === 'DraftKings'" class="body-2">
              {{ item.FantasyPointsDraftKings }}
            </p>
          </template>
        </v-data-table>
      </div>

      <!-- //* season stats... -->
      <div class="mt-n3 pa-2">
        <p class="text-h5 white--text font-weight-bold mt-3">Season Logs</p>
        <v-data-table
          :headers="dynamicSeasonHeader"
          :items="seasonStats.data"
          class="elevation-1"
          hide-default-footer
          sort-by="Day"
          sort-desc
          mobile-breakpoint="0"
        >
          <template
            v-for="h in dynamicSeasonHeader"
            v-slot:[`header.${h.value}`]="{ dynamicSeasonHeader }"
          >
            <v-tooltip bottom :key="h.text">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ h.text }}</span>
              </template>
              <span>{{ h.hint }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.Day="{ item }">
            <p class="blue--text">{{ item.Day | dayFormatV2 }}</p>
          </template>

          <template v-slot:item.FantasyPointsDraftKings="{ item }">
            <p v-if="operator === 'FanDuel'" class="body-2">
              {{ item.FantasyPointsFanDuel }}
            </p>

            <p v-if="operator === 'DraftKings'" class="body-2">
              {{ item.FantasyPointsDraftKings }}
            </p>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "MlbSummary",
  props: {
    stats: {
      type: [Array, Object],
      default: () => [],
    },
    seasonStats: {
      type: [Array, Object],
      default: () => [],
    },
    Position: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    dynamicRecentHeader() {
      if (this.stats !== null) {
        if (this.Position.position.includes("P")) {
          return this.PitcherHeaders;
        } else {
          return this.HitterHeaders;
        }
      }
    },
    dynamicSeasonHeader() {
      if (this.stats !== null) {
        if (this.Position.position.includes("P")) {
          return this.PitcherSeasonHeaders;
        } else {
          return this.HitterSeasonHeaders;
        }
      }
    },
  },

  data() {
    return {
      HitterHeaders: [
        { text: "Week", value: "Week", width: "auto" },
        {
          text: "Opponent",
          value: "Opponent",
          hint: "Opponent",
        },
        {
          text: "AB",
          value: "AtBats",
          hint: "AtBats",
        },
        {
          text: "R",
          value: "Runs",
          hint: "Runs",
        },
        {
          text: "H",
          value: "Hits",
          hint: "Hits",
        },
        {
          text: "2B",
          value: "Doubles",
          hint: "Doubles",
        },
        {
          text: "3B",
          value: "Triples",
          hint: "Triples",
        },
        {
          text: "HR",
          value: "HomeRuns",
          hint: "HomeRuns",
        },
        {
          text: "RBI",
          value: "RunsBattedIn",
          hint: "Runs BattedIn",
        },
        {
          text: "SO",
          value: "Strikeouts",
          hint: "Strikeouts",
        },
        {
          text: "SB",
          value: "StolenBases",
          hint: "Stolen Bases",
        },
        {
          text: "CS",
          value: "CaughtStealing",
          hint: "Caught Stealing",
        },
        {
          text: "AVG",
          value: "BattingAverage",
          hint: "Batting Average",
        },
        {
          text: "OBP",
          value: "OnBasePercentage",
          hint: "On Base Percentage",
        },
        {
          text: "SLG",
          value: "SluggingPercentage",
          hint: "Slugging Percentage",
        },
        {
          text: "OPS",
          value: "OnBasePlusSlugging",
          hint: "On Base Plus Slugging",
        },
        {
          text: "Started",
          value: "Started",
          hint: "Started",
        },
      ],

      PitcherHeaders: [
        {
          text: "Season",
          value: "Season",
          hint: "Season",
          width: "auto",
        },
        {
          text: "Team",
          value: "Team",
          hint: "Team",
        },
        {
          text: "W",
          value: "Wins",
          hint: "Wins",
        },
        {
          text: "L",
          value: "Losses",
          hint: "Losses",
        },
        {
          text: "ERA",
          value: "EarnedRunAverage",
          hint: "Earned Run Average",
        },
        { text: "SV", value: "Saves", hint: "Saves" },
        {
          text: "IP",
          value: "InningsPitchedFull",
          hint: "Innings Pitched Full",
        },
        {
          text: "H",
          value: "PitchingHits",
          hint: "Pitching Hits",
        },
        {
          text: "R",
          value: "PitchingRuns",
          hint: "Pitching Runs",
        },
        {
          text: "ER",
          value: "PitchingEarnedRuns",
          hint: "Pitching Earned Runs",
        },
        {
          text: "HR",
          value: "PitchingHomeRuns",
          hint: "Pitching Home Runs",
        },
        {
          text: "BB",
          value: "PitchingWalks",
          hint: "Pitching Walks",
        },
        {
          text: "SO",
          value: "PitchingStrikeouts",
          hint: "Pitching Strikeouts",
        },
        {
          text: "Avg",
          value: "PitchingBattingAverageAgainst",
          hint: "Pitching Batting Average Against",
        },
        {
          text: "WHIP",
          value: "WalksHitsPerInningsPitched",
          hint: "Walks Hits Per Innings Pitched",
        },
      ],

      HitterSeasonHeaders: [
        { text: "Season", value: "Season", width: "auto" },
        { text: "Team", value: "Team", hint: "Team" },
        {
          text: "AB",
          value: "AtBats",
          hint: "AtBats",
        },
        {
          text: "R",
          value: "Runs",
          hint: "Runs",
        },
        {
          text: "H",
          value: "Hits",
          hint: "Hits",
        },
        {
          text: "2B",
          value: "Doubles",
          hint: "Doubles",
        },
        {
          text: "3B",
          value: "Triples",
          hint: "Triples",
        },
        {
          text: "HR",
          value: "HomeRuns",
          hint: "HomeRuns",
        },
        {
          text: "RBI",
          value: "RunsBattedIn",
          hint: "Runs BattedIn",
        },
        {
          text: "SO",
          value: "Strikeouts",
          hint: "Strikeouts",
        },
        {
          text: "SB",
          value: "StolenBases",
          hint: "Stolen Bases",
        },
        {
          text: "CS",
          value: "CaughtStealing",
          hint: "Caught Stealing",
        },
        {
          text: "AVG",
          value: "BattingAverage",
          hint: "Batting Average",
        },
        {
          text: "OBP",
          value: "OnBasePercentage",
          hint: "On Base Percentage",
        },
        {
          text: "SLG",
          value: "SluggingPercentage",
          hint: "Slugging Percentage",
        },
        {
          text: "OPS",
          value: "OnBasePlusSlugging",
          hint: "On Base Plus Slugging",
        },
        {
          text: "Started",
          value: "Started",
          hint: "Started",
        },
      ],

      PitcherSeasonHeaders: [
        { text: "Season", value: "Season", width: "auto" },
        { text: "Team", value: "Team", hint: "Team" },
        {
          text: "W",
          value: "Wins",
          hint: "Wins",
        },
        {
          text: "L",
          value: "Losses",
          hint: "Losses",
        },
        {
          text: "ERA",
          value: "EarnedRunAverage",
          hint: "Earned Run Average",
        },
        { text: "SV", value: "Saves", hint: "Saves" },
        {
          text: "IP",
          value: "InningsPitchedFull",
          hint: "Innings Pitched Full",
        },
        {
          text: "H",
          value: "PitchingHits",
          hint: "Pitching Hits",
        },
        {
          text: "R",
          value: "PitchingRuns",
          hint: "Pitching Runs",
        },
        {
          text: "ER",
          value: "PitchingEarnedRuns",
          hint: "Pitching Earned Runs",
        },
        {
          text: "HR",
          value: "PitchingHomeRuns",
          hint: "Pitching Home Runs",
        },
        {
          text: "BB",
          value: "PitchingWalks",
          hint: "Pitching Walks",
        },
        {
          text: "SO",
          value: "PitchingStrikeouts",
          hint: "Pitching Strikeouts",
        },
        {
          text: "Avg",
          value: "PitchingBattingAverageAgainst",
          hint: "Pitching Batting Average Against",
        },
        {
          text: "WHIP",
          value: "WalksHitsPerInningsPitched",
          hint: "Walks Hits Per Innings Pitched",
        },
      ],
    };
  },
};
</script>

<style scoped>
.basil {
  background-color: #fffbe6 !important;
}

.basil--text {
  color: #356859 !important;
}
</style>
